import { Box } from '@theme-ui/components';

import FormattedMoney from '@app/components/FormattedMoney';

import type { PricingPageShopProduct_magento2_products_items_Magento2_BundleProduct_priceRange as PriceRange } from '../../hook/__generated__/PricingPageShopProduct';
import { CurrentPrice, OldPrice } from './styles';

const PriceComponent = ({ price }: { price?: PriceRange | null }) => {
  const { regularPrice, finalPrice, discount } = price?.minimumPrice ?? {};

  if (discount?.amountOff) {
    return (
      <Box mb={3}>
        <CurrentPrice mb={3} data-testid="product-discount-price">
          <FormattedMoney {...finalPrice} />
        </CurrentPrice>
        <OldPrice data-testid="product-old-price">
          <FormattedMoney {...regularPrice} />
        </OldPrice>
      </Box>
    );
  }

  return (
    <Box mb={3}>
      <CurrentPrice data-testid="product-price">
        <FormattedMoney {...finalPrice} />
      </CurrentPrice>
    </Box>
  );
};

export default PriceComponent;
